import React from 'react';

import * as S from './styles';
import ExtraFieldInputRow from '../ExtraFieldInputRow';
import { ExtraFieldShowRow } from '../ExtraFieldShowRow';

export default function ExtraFields({ fields, show, onRemoveField }) {
  return (
    <S.ExtraFields>
      {show ? (
        <>
          {fields.map((field, index) => (
            <ExtraFieldShowRow
              id={`valor-extra-${index}`}
              key={field?.label}
              label={field?.label}
              value={field?.value}
              dollarValue={field?.dollarValue}
              showToDriver={field?.showToDriver}
              onRemoveField={() => onRemoveField(index)}
            />
          ))}
        </>
      ) : (
        <>
          {fields.map((field, index) => (
            <ExtraFieldInputRow
              id={`valor-extra-${index}`}
              key={field?.label}
              label={field?.label}
              value={field?.value}
              dollarValue={field?.dollarValue}
              showToDriver={field?.showToDriver}
              onRemoveField={() => onRemoveField(index)}
            />
          ))}
        </>
      )}
    </S.ExtraFields>
  );
}
